import React, { useMemo } from 'react';
import { TUseTipsByDefault } from 'types';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';
import { Radio } from 'components/Radio/Radio';
import Text from 'components/Text/Text';

interface IProps {
	setTips: (value: Nullable<number>) => void;
	setDefaultTips: (value: TUseTipsByDefault) => void;
	defaultTips: TUseTipsByDefault;
	tipsNumber: '0' | '1' | '2' | '3';
}

export const TipsFieldNew: React.FC<IProps> = ({ setTips, setDefaultTips, defaultTips, tipsNumber }) => {
	const { t } = useTranslation('error');
	const isDefault = defaultTips === tipsNumber;

	const validationRules = useMemo<Rule[]>(
		() => [
			({ getFieldsValue }) => ({
				validator: (_, value) => {
					const otherTips = Object.values(getFieldsValue(['tips0', 'tips1', 'tips2', 'tips3'])).filter(
						(tips, i) => tips != null && i !== Number(tipsNumber),
					);

					if (value != null && otherTips.includes(value)) {
						return Promise.reject(new Error(t('thisValueAlreadyExistsInAnotherTips')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t, tipsNumber],
	);

	const handleRadioChange = () => {
		setDefaultTips(tipsNumber);
	};

	return (
		<div className="min-w-0 flex-1 flex flex-col gap-2">
			<FormInputNew
				testId={`Tips${tipsNumber}Field`}
				type="number"
				name={`tips${tipsNumber}`}
				label={isDefault ? `tips${tipsNumber}DefaultLabel` : `tips${tipsNumber}Label`}
				min={0}
				max={100}
				precision={1}
				validationRules={validationRules}
				onChangeNumber={setTips}
			/>
			<Radio
				checked={isDefault}
				name="defaultTips"
				testId={`Tips${tipsNumber}DefaultRadio`}
				onChange={handleRadioChange}>
				<Text translationNameSpace="form" translationKey="useByDefault" size="xs" theme="neutralMedium" />
			</Radio>
		</div>
	);
};
